export default __webpack_public_path__ + "static/media/fridge2-beforeA.dfea0659.jpg";